<template>
  <TabsBuilder :isDarkMode="isDarkMode" :navigationDescription="componentData.description">
    <li
      v-for="(division, index) in divisions"
      slot="tab-bar"
      :key="index"
      class="owc-division-switcher__item"
      :class="{
        'owc-division-switcher__item--active': division.isActive,
        'owc-division-switcher__item--dark': isDarkMode,
      }"
    >
      <a
        class="wb-button wb-button--tertiary wb-button--medium"
        :class="{
          'wb-button--theme-dark': isDarkMode,
        }"
        :aria-current="division.isActive ? 'page' : false"
        :href="division.link.url"
        :target="division.link.target"
        >{{ division.link.label }}</a
      >
    </li>
  </TabsBuilder>
</template>

<script lang="ts">
/**
 * `DivisionSwitcher` - The division switcher is a row of tabs changing the page content to the Mercedes-Benz retail business units.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import TabsBuilder from '@owc-packages/TabsBuilder/src/TabsBuilder.vue';
import { DivisionSwitcherComponent } from './DivisionSwitcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as DivisionSwitcherComponent).extend({
  name: 'owc-division-switcher',
  components: {
    TabsBuilder,
  },
  mixins: [OwcDataComponent],
  computed: {
    divisions: function() {
      return this.componentData?.divisions;
    },
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
});
</script>

<style lang="scss">
.owc-division-switcher {
  &__item {
    $this: &;
    display: block;
    border: none;

    &--active {
      .wb-button {
        border-bottom: 2px solid var(--wb-blue-45);

        color: var(--wb-grey-20);
      }
    }
    &--dark {
      .wb-button {
        color: var(--wb-grey-70);
      }
      &#{$this}--active {
        .wb-button {
          color: var(--wb-white);
        }
      }
    }
    .wb-button {
      width: 100%;
      min-width: 5rem;
      border-radius: 0;

      color: var(--wb-grey-45);

      // keeps tab text on a single line
      white-space: nowrap;

      &:focus {
        border-color: var(--wb-blue-45);
      }
    }
  }
}
</style>
